export default function (target, value) {
  function push(_ref) {
    var state = _ref.state,
        resolve = _ref.resolve;

    if (!resolve.isTag(target, 'state')) {
      throw new Error('Cerebral operator.push: You have to use the STATE TAG as first argument');
    }

    state.push(resolve.path(target), resolve.value(value));
  }

  push.displayName = 'operator.push(' + String(target) + ')';

  return push;
}
//# sourceMappingURL=push.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/cerebral/es/operators/push.js
// module id = 772
// module chunks = 1